import { Quote } from '@shared/types/quote';
import { MemoryAssociableEntityIds } from 'clerk_common';

export function collectMemoryAssociableEntitiesForQuote(
  quote: Quote | null
): MemoryAssociableEntityIds {
  if (!quote) return {};
  const quotes = quote.id ? [quote.id] : [];
  const originators = quote.originator?.id ? [quote.originator.id] : [];
  return { quotes, originators };
}
